import styled from 'styled-components'

// #region - selling/for-professionals
export const SellingForUsersPageWrapper = styled.div`
    margin-bottom: 100px;
    & * {
        font-family: 'Jarkarta';
    }
    & > * {
        max-width: 700px;
        margin: 0 auto;
    }
    @media (max-width: 700px) {
        & > * {
            width: 90%;
            max-width: 90%
        }
    }
`

export const Text = styled.p`
    font-size: 18px;
    line-height: 1.6;
    margin: 18px auto;
`
export const LinkText = styled.a`
    color: #125F3F;

    &:hover {
        text-decoration: underline;
    }
`
export const BannerImageContainer = styled.div`
    max-width: 100%;
    width: 100%;
    height: 500px;
    background: linear-gradient(rgba(18, 95, 63, 0.7), rgba(18, 95, 63, 0.7)), url(${({ imageUrl }) => imageUrl});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 15px;
    color: #fff;
    padding: 10px 15px;
    margin-bottom: 80px;
`
export const BannerHeadingText = styled.h1`
    font-weight: 500;
    font-size: 40px;
    text-align: center;

    @media (max-width: 825px) {
        font-size: 28px;
    }
`
export const BannerBlurb = styled.p`
    font-size: 24px;
    text-align: center;
    max-width: 900px;
    
    @media (max-width: 825px) {
        font-size: 18px;
    }
`
export const HeadingText = styled.h2`
    font-size: 24px;
    font-weight: normal;
    margin-top: 45px;
    margin-bottom: 18px;
`
export const SubHeadingText = styled.h3`
    font-size: 18px;
    font-weight: 500;
    margin-top: 45px;
    margin-bottom: 9px;
`
export const SubHeadingDescription = styled.p`
    font-size: 18px;
    line-height: 1.6;
    margin: 0px auto;
`

export const CTAButton = styled.button`
    background: #fff;
    color: #125F3F;
    padding: 10px 0px;
    border-radius: 25px;
    width: 250px;
`
// #endregion